import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createUnknownComponentVNode as _$cc, className as _$cn, createElementVNode as _$ce } from 'intact-react';
import { getRestProps } from '../utils';
import { Icon } from '../icon';
import { makeButtonStyles } from './styles';
import { DynamicButton } from './dynamicButton';
import { Wave } from '../wave';
import { button as theme } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    type = _this$get.type,
    className = _this$get.className,
    size = _this$get.size,
    icon = _this$get.icon,
    circle = _this$get.circle,
    ref = _this$get.ref,
    key = _this$get.key,
    tabindex = _this$get.tabindex,
    tagName = _this$get.tagName,
    htmlType = _this$get.htmlType,
    fluid = _this$get.fluid,
    children = _this$get.children,
    loading = _this$get.loading,
    disabled = _this$get.disabled,
    name = _this$get.name,
    ghost = _this$get.ghost;
  var _this$config = this.config,
    cls = _this$config.cls,
    k = _this$config.k;
  var checked = this.isChecked();
  var isIcon = function isIcon(child) {
    return child.tag === Icon || child.className && child.className.indexOf('icon') > -1;
  };
  var iconSide;
  // hack for loading transition of width
  if (!icon && Array.isArray(children)) {
    children.forEach(function (child, index) {
      if (child) {
        // whether the icon is on the left side or right
        if (index === 0) {
          if (isIcon(child)) {
            iconSide = 'left';
          }
        } else if (index === children.length - 1) {
          if (isIcon(child)) {
            iconSide = 'right';
          }
        }
      }
    });
  }
  var classNameObj = (_classNameObj = {}, _classNameObj[cls('btn')] = true, _classNameObj[cls(size)] = size !== 'default', _classNameObj[cls(type)] = true, _classNameObj[cls("btn-icon")] = icon, _classNameObj[className] = className, _classNameObj[cls('circle')] = circle, _classNameObj[cls('loading')] = loading, _classNameObj[cls('fluid')] = fluid, _classNameObj[cls('active')] = checked, _classNameObj[cls('disabled')] = disabled || loading, _classNameObj[cls('ghost')] = ghost, _classNameObj[makeButtonStyles(k, iconSide)] = true, _classNameObj);
  var loadingIcon = _$cc(Icon, {
    'className': _$cn("ion-load-c " + k + "-icon-loading"),
    'size': size /*loadingSizeMap[size]*/,
    'key': 'k-loading',
    'rotate': true
  }, 'k-loading');
  var buttonGroup = this.buttonGroup;
  var checkType = buttonGroup ? buttonGroup.get('checkType') : 'none';
  var isCheckType = checkType !== 'none';
  var typeStyles = theme[type];
  var waveColor = typeStyles && typeStyles.borderColor || theme.primary.borderColor;
  return _$cc(Wave, {
    'disabled': loading || disabled || type === 'none' || type === 'link',
    'inset': type === 'flat' ? '-1px' : '-2px',
    'color': waveColor,
    'children': _$cc(DynamicButton, _extends({
      'className': _$cn(classNameObj),
      'tagName': tagName
    }, getRestProps(this), {
      'ref': this.elementRef,
      'tabindex': disabled || loading ? '-1' : tabindex,
      'ev-click': this.onClick,
      'ev-mouseup': this.onMouseUp,
      'htmlType': htmlType,
      'name': isCheckType ? null : name,
      'children': [loading ? iconSide === 'right' ? [children, loadingIcon] : [loadingIcon, children] : children, isCheckType ? _$ce(64, 'input', null, 1, _$cn(k + "-button-input"), {
        'type': checkType,
        'name': name,
        'checked': checked,
        'tabindex': '-1'
      }) : undefined]
    }), null, this.elementRef)
  });
}
;